import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-guides-item-summary',
  templateUrl: './guides-item-summary.component.html',
  styleUrls: ['./guides-item-summary.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService],
})
export class GuidesItemSummaryComponent implements OnInit {
  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** PIPES */
  datePipe: DatePipe = new DatePipe("en-US");

  /** LABELS */
  translations: Record<string, string> = {};

  /** DIALOG */
  displayModal: boolean = false;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** COMPONENT */
  listYears: any[];
  listSummaries : any[];

  // Tabla Coordinaciones
  coordinations = [
    { field: "coordName", header: "lbl_coordination" },
    { field: "amount", header: "lbl_amount" },
    { field: "total", header: "lbl_total" },
    { field: "amountX", header: "lbl_amount" },
    { field: "totalX", header: "lbl_total" },
  ];
  coordinationsTableFilters = ["coordName", "amount","total","amountX", "totalX"];

  language: string;

  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tovpilCrudService: TovpilCrudService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService
  ) { 
    this.createDataForm();
    this.initConfigs();

     // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
     const user = this.globalUserPreferences.preferences;
     const securitySelected = this.globalUserPreferences;
 
     if (securitySelected?.tokenProfile && user && user.device === "2") {
       this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
     } else {
       //this.globalUserPreferences.preferences.currentUser = currentUser;
     }
  }

  /**
   * The `createDataForm` function in TypeScript creates a reactive form with specific form controls.
   */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedYear : new FormControl(null),
      backToStoreId: new FormControl(null),
      selStoreId : new FormControl(null),
      token : new FormControl(null),
    });

    // console.debug(
    //   "MatNatReqDtlComponent - REACTIVE FORM: ",
    //   JSON.stringify(this.globalUserDataForm.getRawValue(), null, 2)
    // );
  }

  
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  ngOnInit(): void {
    this.getQueryParams();
    this.getSecurity();
    this.getInitialData();
  }

  getQueryParams(){
    this.route.queryParams.subscribe((params) => {
      this.globalUserDataForm.patchValue({
        token: params.token ?? null,
      });
    });
  }

  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE EN CASO DE QUE SEA NULL
    if (securityControl === null || Object.keys(securityControl).length === 0) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }
    await this.getTranslatedLabels();
  }

  async getTranslatedLabels() {
    const language =
      this.globalUserPreferences?.preferences?.language || this.language;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  async getInitialData(){
    const years = await this.apiService.getValidYears();
    this.listYears = years;
    await this.getData();    
    this.blocked = false;
  }

  async getData(){
    
  }

  onChangeYear(){
    
  }

  exportPdf() {
    try {
      if (this.listSummaries === null || this.listSummaries.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const filteredJSON = this.listSummaries.map((order) => ({
         
        }));

        const keysArray = filteredJSON.map((order) => Object.keys(order));
        const valuesArray = filteredJSON.map((order) => Object.values(order));

        let fileName = ``;
        this.filesService.tovpilExportPDF(keysArray[0], valuesArray, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to PDF:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_pdf}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  exportExcel() {
    try {
      if (this.listSummaries === null || this.listSummaries.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`,
          life: 3000
        });
      } else {
        const orderNumber = this.translations.lbl_number + " " + this.translations.lbl_order;
        const orderDate = this.translations.lbl_date + " " + this.translations.lbl_order;
        const requiredTo = this.translations.lbl_required + " " + this.translations.lbl_to;

        const filteredJSON = this.listSummaries.map((order) => ({
          [this.translations.lbl_status]: order ? (order?.hdrStatus || 'S/N') : 'S/N',
        }));

        let fileName = ``;
        this.filesService.tovpilExportXLSX(filteredJSON, fileName);
      }
    } catch (error) {
      console.error("An error occurred while exporting to Excel:", error);
      this.messageService.add({
        severity: 'error',
        summary: `${this.translations.lbl_error} ${this.translations.lbl_export_to_excell}`,
        detail: `${this.translations.lbl_then_try_it_again}`,
        life: 5000
      });
    }
  }

  selectRecord(str: string) {
    let next: boolean = false;
    let backToStoreId = this.globalUserDataForm.get('backToStoreId').value || null;
    const selStoreId = this.globalUserDataForm.get('selStoreId').value || null;
    const token = this.globalUserDataForm.get('token').value || null;

    if (backToStoreId == null) {
      backToStoreId = this.globalUserPreferences.storeId;
      next = true;
    } else {
      let vals = backToStoreId.split(",");
      if (selStoreId != null && vals.length < 2) {
        backToStoreId = backToStoreId + "," + selStoreId;
        next = true;
      } else {
        next = false;
      }
    }
    if (next) {
      this.router.navigate(['reports/sentGuides'], { queryParams: { token: token, selStoreId: str } }).then(() => {
        window.location.reload();
      });
    }
  }
}
